import React from 'react';
import { PrivacyBox } from './styles';
import Footer from '../_partials/Footer';
import { Flex, Image, Layout, Typography } from 'antd';

const { Title, Paragraph, Text } = Typography;

export default function Privacy() {
  const myStyleLayout = {
    height: '100%',
    background: 'linear-gradient(90deg, #2e394b 0%, #4e6180 50%, #2e394b 100%)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important",
  };

  return (
    <Layout className="layout" style={myStyleLayout}>
      <Flex vertical align="center" justify="center" style={{ marginTop: 20 }}>
        <Image width={170} height="auto" src="images/logo-horizontal-02.png" preview={false} />
        <Title level={8} style={{ color: '#fff' }}>
          Política de Privacidade do Usuário
        </Title>
      </Flex>
      <PrivacyBox>
        {' '}
        <Typography>
          <Title level={2}>Política de Privacidade – Nobre Eventos</Title>
          <Paragraph>
            <Text strong>Última atualização:</Text> 28/08/2025
          </Paragraph>

          <Paragraph>
            A <Text strong>Nobre</Text> (“<Text strong>Nobre Eventos</Text>”, “nós”, “nosso” ou “nos”) valoriza a{' '}
            <Text strong>privacidade</Text>, a <Text strong>segurança</Text> e a <Text strong>transparência</Text> no
            tratamento de dados pessoais. Este documento tem como objetivo esclarecer como os dados dos usuários são
            coletados, utilizados, armazenados e protegidos dentro do sistema <Text strong>Nobre Eventos</Text>,
            disponível em{' '}
            <a
              href="https://app.nobreeventos.com.br"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'underline' }}
            >
              https://app.nobreeventos.com.br
            </a>
            .
          </Paragraph>

          <Paragraph>
            Ao utilizar o sistema, você reconhece e concorda com as práticas descritas nesta{' '}
            <Text strong>Política de Privacidade</Text>.
          </Paragraph>

          <Title level={3}>1. Sobre o Sistema</Title>
          <Paragraph>
            O <Text strong>Nobre Eventos</Text> é uma plataforma <Text strong>privada</Text> para gestão e administração
            de eventos da empresa Nobre. O acesso ao sistema é <Text strong>restrito</Text>: somente usuários
            previamente cadastrados e autorizados pelo administrador da plataforma podem utilizá-lo. Não é possível
            criar contas de forma autônoma; toda permissão de acesso é concedida exclusivamente pelo{' '}
            <Text strong>dono do sistema</Text> ou por usuários com perfil administrativo.
          </Paragraph>

          <Title level={3}>2. Coleta de Informações</Title>
          <Paragraph>Ao utilizar o sistema, poderemos coletar diferentes tipos de informações, incluindo:</Paragraph>

          <Paragraph>
            <Text strong>2.1. Dados de cadastro</Text>
            <ul>
              <li>Nome completo</li>
              <li>Endereço de e-mail</li>
              <li>CPF ou CNPJ (quando aplicável)</li>
              <li>Telefone de contato</li>
              <li>Dados de autenticação (login e senha criados pelo administrador)</li>
            </ul>
          </Paragraph>

          <Paragraph>
            <Text strong>2.2. Dados de uso</Text>
            <ul>
              <li>Informações sobre acessos realizados (data, hora, IP, navegador utilizado)</li>
              <li>Funcionalidades acessadas e ações executadas dentro do sistema</li>
              <li>Permissões vinculadas ao perfil do usuário</li>
            </ul>
          </Paragraph>

          <Paragraph>
            <Text strong>2.3. Dados de eventos</Text>
            <ul>
              <li>Registros relacionados a eventos administrados no sistema</li>
              <li>Informações sobre equipe, fornecedores, participantes e documentos associados</li>
            </ul>
          </Paragraph>

          <Title level={3}>3. Finalidade do Tratamento de Dados</Title>
          <Paragraph>
            Os dados coletados têm como finalidade:
            <ul>
              <li>Permitir a autenticação e o acesso ao sistema</li>
              <li>Garantir a segurança, rastreabilidade e integridade das informações</li>
              <li>Controlar e gerenciar permissões de acordo com o perfil do usuário</li>
              <li>Facilitar a administração de eventos</li>
              <li>Cumprir obrigações legais e regulatórias</li>
              <li>Prevenir fraudes e acessos não autorizados</li>
            </ul>
          </Paragraph>

          {/* repita a mesma estrutura para os demais itens (4 até 11) */}

          <Title level={3}>11. Contato</Title>
          <Paragraph>
            Em caso de dúvidas, solicitações ou para exercer seus direitos de titular de dados, entre em contato através
            do canal oficial disponibilizado pela administração da empresa <Text strong>Nobre</Text>.
          </Paragraph>
        </Typography>
      </PrivacyBox>
      <Footer bg="transparent" color="#fff" />
    </Layout>
  );
}
